import { useMutation } from '@tanstack/react-query';
import { LoginApi, VerifySignInCodePostModel } from '../../../apis/LoginApi/LoginApi.ts';
import { CurrentUser } from '../CurrentUser.ts';
import { rememberSignedInUser } from '../rememberSignedInUser.ts';

export function useVerifySignInCodeMutation() {
    return useMutation<CurrentUser, Error, VerifySignInCodePostModel>({
        mutationFn: async (data) => new CurrentUser(await LoginApi.verifySignInCode(data)),
        onSuccess: rememberSignedInUser,
    });
}
